import { createContext } from "react";
const GetWhatsAppLinkContext = createContext({});
export default GetWhatsAppLinkContext;
